import React from 'react';
import styled from 'styled-components';
import SettingsPanel from '../blanks/settings-panel/SettingsPanel';
import AppRoutes from './routes';
import WinManagerContextProvider from '../../providers/WinManagerContext/provider';
import LogicaContextProvider from '../../providers/LogicaContext/provider';

const StyledRoot = styled.div`
  padding-bottom: var(--windows-menu-line-height);
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
`;

function LayoutGrid() {
  return (
    <WinManagerContextProvider>
      <LogicaContextProvider>
        <StyledRoot>
          <AppRoutes />
          {/* <SettingsToggle /> */}
          <SettingsPanel />
        </StyledRoot>
      </LogicaContextProvider>
    </WinManagerContextProvider>
  );
}

export default LayoutGrid;
